"use strict";

exports.__esModule = true;
exports.isResponseSuccessful = isResponseSuccessful;

function isResponseSuccessful(status) {
  if (status === 0 || status > 399 && status < 600) {
    return false;
  }

  return true;
}


//////////////////
// WEBPACK FOOTER
// ./~/@elastic/apm-rum-core/dist/lib/common/http/response-status.js
// module id = 179
// module chunks = 0